import request from '@/utils/request'
/**
* @fileOverview 用户管理
*/

/**
* @description 用户列表
* @param {string} params.search 搜索条件
* @param {number} params.page 页码
*/
export function users(params) {
  return request({
    url: '/users',
    method: 'get',
    params
  })
}

/**
  * @description 创建编辑用户前置数据
  */
export function storeBefore() {
  return request({
    url: '/users/storeBefore',
    method: 'get'
  })
}

/**
  * @description 创建用户
  * @param {string} data.email 电子邮件
  * @param {string} data.firstname 名
  * @param {string} data.lastname 姓
  * @param {string} data.phone 手机号
  * @param {number} data.role 用户角色
  * @param {number} data.manager_id 客户经理ID
  * @param {Array} data.user_label 用户标签
  * @param {number} data.group_id 分组ID
   * @param {string} data.group_review_cates 初评分类
 */
export function createUsers(data) {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}

/**
  * @description 编辑用户
  * @param {number} id 用户ID
  * @param {string} data.email 电子邮件
  * @param {string} data.firstname 名
  * @param {string} data.lastname 姓
  * @param {string} data.phone 手机号
  * @param {number} data.role 用户角色
  * @param {number} data.manager_id 客户经理ID
  * @param {Array} data.user_label 用户标签
  * @param {number} data.group_id 分组ID
  * @param {string} data.group_review_cates 初评分类
  */
export function editUsers(id, data) {
  return request({
    url: `/users/${id}`,
    method: 'put',
    data
  })
}

/**
  * @description 编辑用户的客户经理
  * @param {string} data.id 用户
  * @param {string} data.manager_id 客户经理id, 删除传0
  */
export function editUsersManager(data) {
  return request({
    url: `/users/manager`,
    method: 'post',
    data
  })
}

/**
  * @description 日志（奖项、用户、作品）
  * @param {string} type 类型（1-奖项 2-用户 3-作品）
  * @param {string} params.title 搜索条件
  * @param {string} params.start_date 开始时间，如2020-03-30
  * @param {string} params.end_date 结束时间
  */
export function logs(type, params) {
  return request({
    url: `/users/logs/${type}`,
    method: 'get',
    params
  })
}

// 分组管理
/**
  * @description 分组列表
  */
export function groups() {
  return request({
    url: `/groups`,
    method: 'get'
  })
}

/**
  * @description 新增分组
  * @param {string} data.title 分组名称
  */
export function addGroup(data) {
  return request({
    url: `/groups`,
    method: 'post',
    data
  })
}

/**
  * @description 编辑分组
  * @param {string} data.title 分组名称
  */
export function editGroup(id, data) {
  return request({
    url: `/groups/${id}`,
    method: 'put',
    data
  })
}

/**
  * @description 删除分组
  */
export function deleteGroup(id) {
  return request({
    url: `/groups/${id}`,
    method: 'delete'
  })
}
